import { render, staticRenderFns } from "./RmpCaptcha.vue?vue&type=template&id=169f29d3&scoped=true"
import script from "./RmpCaptcha.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpCaptcha.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpCaptcha.vue?vue&type=style&index=0&id=169f29d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169f29d3",
  null
  
)

export default component.exports